import { RoadmapContainer } from "../../components";
import * as Styled from "./roadmap-page.styled";

export const RoadmapPage = () => {
  return (
    <Styled.RoadmapPageWrapper>
      <RoadmapContainer />
    </Styled.RoadmapPageWrapper>
  );
};
